import * as React from 'react';

/**
 * Tracks the height of a toolbar (or any) element with ResizeObserver.
 */
export function useToolbarHeight(element: HTMLElement | null): number {
    const [height, setHeight] = React.useState(0);

    React.useLayoutEffect(() => {
        if (!element) return;

        const observer = new ResizeObserver(entries => {
            const entry = entries[0];
            if (!entry) return;
            setHeight(Math.max(0, Math.round(entry.contentRect.height)));
        });

        observer.observe(element);
        return () => observer.disconnect();
    }, [element]);

    return element ? height : 0;
}
